module.exports = __webpack_public_path__ + "img/liability-explained.42eedc63.svg";